
import { defineComponent } from 'vue'
import BaseLink from '@/components/BaseLink.vue'
import Card from '@/components/Card.vue'
import RT from '@/components/ResponsiveTable.vue'
import RBC from '@/components/ResponsiveBodyCell.vue'
import RBCPinned from '@/components/ResponsiveBodyCellPinned.vue'
import RHC from '@/components/ResponsiveHeadCell.vue'
import RHCPinned from '@/components/ResponsiveHeadCellPinned.vue'
import { formatCurrency } from '@/libs/formatCurrency'

export default defineComponent({
  components: {
    BaseLink,
    Card,
    RT,
    RBC,
    RBCPinned,
    RHC,
    RHCPinned
  },

  props: {
    loans: {
      required: true,
      type: Array
    }
  },

  setup () {
    return {
      formatCurrency
    }
  }
})
